import React from "react";
import { Card, CardContent, Typography, Avatar } from "@mui/material";

const YogaIDCard = ({ name, age, photo }) => {
  return (
    <Card
      sx={{
        width: 450,
        height: 350,
        borderRadius: 4,
        boxShadow: 3,
        textAlign: "center",
        padding: 2,
        background: "#f5f5f5",
      }}
    >
      <Typography variant="h6" color="primary">
        Yogamatic ID Card
      </Typography>
      <Avatar
        src={photo}
        sx={{ width: 100, height: 100, margin: "10px auto" }}
      />
      <CardContent>
        <Typography variant="h5" fontWeight="bold">
          {name}
        </Typography>
        <Typography variant="body1">Age: {age}</Typography>
        <Typography
          variant="body2"
          sx={{ marginTop: 2, fontWeight: "bold", color: "green" }}
        >
          Yoga Center: Yogametic
        </Typography>
      </CardContent>
    </Card>
  );
};

export default YogaIDCard;
